















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import api from "../honcierge-api"
import { AxiosError } from "axios"
import { diff_match_patch } from "diff-match-patch"
import Diff from "@/components/Diff.vue"

import { DataTableHeader } from "vuetify/types"
import { Version } from "types/index"

@Component({
  components: {
    Diff,
  },
})
export default class Versions extends Vue {
  @Prop({ default: -1 })
  private articleId!: number

  private versions: Version["index"]["versions"] = []
  private totalCount = 0
  private loading = true
  private rowsPerPageItems: [number, number] = [10, 25]

  private selectedVersionId = -1
  private version: {
    editorData: string
    title: string
    rssTitle: string
    overview: string
  } = { editorData: "", title: "", rssTitle: "", overview: "" }

  private beforeTitle = ""
  private afterTitle = ""
  private diffTitle = ""

  private beforeRssTitle = ""
  private afterRssTitle = ""
  private diffRssTitle = ""

  private beforeOverview = ""
  private afterOverview = ""
  private diffOverview = ""

  private beforeEditorData = ""
  private afterEditorData = ""
  private diffEditorData = ""

  private pagination = {
    page: 1,
    itemsPerPage: 10,
    sortBy: ["createdAt"],
    sortDesc: [true],
  }

  get headers(): DataTableHeader[] {
    return [
      { text: "表示", value: "select", sortable: false },
      { text: "種別", value: "event" },
      { text: "日付", value: "createdAt" },
      { text: "更新者", value: "whodunnit" },
    ]
  }

  private displayDiff() {
    if (this.articleId !== -1) {
      const dmp = new diff_match_patch()
      api
        .getVersion(this.articleId, this.selectedVersionId)
        .then((response) => {
          this.version = response.data.version
          for (const [key, value] of Object.entries(this.version)) {
            if (key === "title") {
              if (value) {
                this.beforeTitle = this.filter(value[0])
                this.afterTitle = this.filter(value[1])
                const diff = dmp.diff_main(this.beforeTitle, this.afterTitle)
                this.diffTitle = dmp.diff_prettyHtml(diff)
              } else {
                this.beforeTitle = ""
                this.afterTitle = ""
                this.diffTitle = ""
              }
            }
            if (key === "rssTitle") {
              if (value) {
                this.beforeRssTitle = this.filter(value[0])
                this.afterRssTitle = this.filter(value[1])
                const diff = dmp.diff_main(
                  this.beforeRssTitle,
                  this.afterRssTitle
                )
                this.diffRssTitle = dmp.diff_prettyHtml(diff)
              } else {
                this.beforeRssTitle = ""
                this.afterRssTitle = ""
                this.diffRssTitle = ""
              }
            }
            if (key === "overview") {
              if (value) {
                this.beforeOverview = this.filter(value[0])
                this.afterOverview = this.filter(value[1])
                const diff = dmp.diff_main(
                  this.beforeOverview,
                  this.afterOverview
                )
                this.diffOverview = dmp.diff_prettyHtml(diff)
              } else {
                this.beforeOverview = ""
                this.afterOverview = ""
                this.diffOverview = ""
              }
            }
            if (key === "editorData") {
              if (value) {
                this.beforeEditorData = this.filter(value[0])
                this.afterEditorData = this.filter(value[1])
                const diff = dmp.diff_main(
                  this.beforeEditorData,
                  this.afterEditorData
                )
                this.diffEditorData = dmp.diff_prettyHtml(diff)
              } else {
                this.beforeEditorData = ""
                this.afterEditorData = ""
                this.diffEditorData = ""
              }
            }
          }
        })
        .catch((error: AxiosError) => {
          this.$toasted.error("履歴の取得に失敗しました")
          console.log(error.stack)
        })
    }
  }

  private filter(value: string): string {
    return value ? value : ""
  }

  @Watch("pagination", { deep: true, immediate: true })
  private onChangePage() {
    this.loading = true
    setTimeout(() => {
      const p = this.pagination
      api
        .getVersions(this.articleId, {
          page: p.page,
          rowsPerPage: p.itemsPerPage,
          sortBy: p.sortBy[0],
          descending: p.sortDesc[0],
        })
        .then((response) => {
          this.versions = []
          this.totalCount = response.data.meta.totalCount
          response.data.versions.forEach((element) => {
            this.versions.push(element)
          })
          this.loading = false
        })
        .catch(() => {
          this.$toasted.error("更新履歴の取得に失敗しました")
          this.loading = false
        })
    }, 500)
  }
}
